import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalDetailsV2Component } from './approval-details-v2.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NbButtonModule, NbCardModule, NbIconModule } from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const component = ApprovalDetailsV2Component

@NgModule({
  declarations: [component],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NbIconModule,
    NbCardModule,
    NbButtonModule
  ],
  exports: [component]
})
export class ApprovalDetailsV2Module { }
